import {useCommonItems} from "../../../../contexts/CommonItensProvider";
import {useAppContext} from "../../../../contexts/AppContext";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {Controller, useForm} from "react-hook-form";
import {getRetiradasData} from "../reports/configs/functions";
import {listaRetiradas} from "./functions";
import {listaUsuariosFilter} from "../../management/people/configs/functions";
import {carregaEquipamentos} from "../equipments/configs/functions";
import {cadastrarProduto, listaProdutoFilho, listaProdutos} from "../products/configs/functions";
import {checkPermissionsAndRedirect, getFormErrorMessage} from "../../../../configs/functions";
import {listaEmpresas} from "../../management/companies/configs/functions";
import {Helmet} from "react-helmet-async";
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Grid,
    MenuItem, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    TextField,
    Typography
} from "@mui/material";
import LinkNavegacao from "../../../common/Link";
import {AddBox, FilterAlt, Home as HomeIcon, Wallet, Warehouse} from "@mui/icons-material";
import PageTitle from "../../../common/PageTitle";
import {
    BlueprintIcon,
    BoxImportantIcon,
    ChainIcon,
    DatabaseExportIcon,
    RequestService2Icon
} from "../../../common/Icons";
import {SelectEmpresaFilter} from "../../../common/SelectEmpresaFilter";
import {TooltipSelectDisabled} from "../../../common/TooltipSelectDisabled";
import {PaginatedUserAutocomplete} from "../../../common/PaginatedUserAutocomplete";
import DateRangePicker from "../../../common/DateRangePicker";
import {LoadingTableRow} from "../../../common/LoadingTableRow";
import {EmptyTableRow} from "../../../common/EmptyTableRow";
import {CustomTablePagination} from "../../../common/CustomTablePagination";
import {RetiradaRow} from "./components/RetiradaRow";
import DownloadIcon from '@mui/icons-material/Download';

export function ListOfRetiradas() {
    const { exibirAlerta, exibirDialog, handleCloseDialog } = useCommonItems();
    const { getEmpresaIdSession, setEmpresaIdSession } = useAppContext();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [numTotalItems, setNumTotalItems] = useState(0);

    const initialDataInicio = dayjs().subtract(1, 'month');
    const initialDataFim = dayjs();

    const [dateRange, setDateRange] = useState([initialDataInicio, initialDataFim]);

    const [retiradas, setRetiradas] = useState([]);
    const [empresas, setEmpresas] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [openForm, setOpenForm] = useState(false);

    const [pessoas, setPessoas] = useState([]);
    const [pagePessoas, setPagePessoas] = useState(0);
    const [isLoadingPessoas, setIsLoadingPessoas] = useState(false);
    const [hasMorePessoas, setHasMorePessoas] = useState(true);

    const [equipamentos, setEquipamentos] = useState([]);
    const [pageEquipamentos, setPageEquipamentos] = useState(0);
    const [isLoadingEquipamentos, setIsLoadingEquipamentos] = useState(false);
    const [hasMoreEquipamentos, setHasMoreEquipamentos] = useState(true);

    const [produtos, setProdutos] = useState([]);
    const [pageProdutos, setPageProdutos] = useState(0);
    const [isLoadingProdutos, setIsLoadingProdutos] = useState(false);
    const [hasMoreProdutos, setHasMoreProdutos] = useState(true);

    const [isExtra, setIsExtra] = useState(['ambos']);

    const [selectedEmpresaId, setSelectedEmpresaId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    const {
        handleSubmit,
        setValue,
        getValues,
        clearErrors,
        reset,
        control,
        formState: { errors },
    } = useForm();

    async function loadReportData(id_empresas, id_pessoa, id_equipamento, id_produto, isExtra, data_inicio, data_fim) {
        try {
            setIsLoading(true);

            data_inicio = dayjs(data_inicio).format('YYYY-MM-DD');
            data_fim = dayjs(data_fim).format('YYYY-MM-DD');

            const filter = {
                data_inicio,
                data_fim,
                limit: rowsPerPage,
                offset: page * rowsPerPage,
            };

            if (id_empresas === 'all') {
                filter.empresa = empresas.map((empresa) => empresa.id);
            } else {
                filter.id_empresas = [id_empresas];
            }

            if (id_pessoa) filter.id_pessoa = id_pessoa;
            if (id_equipamento) filter.id_equipamento = id_equipamento;
            if (id_produto) filter.id_produto = id_produto;
            if (isExtra === 'only_extra') filter.only_extra = true;
            if (isExtra === 'no_extra') filter.no_extra = true;

            const res = await listaRetiradas(filter);
            setRetiradas(res.data.data);
            setNumTotalItems(res.data.numero_total);
        } catch (err) {
            exibirAlerta('Ops', 'Ocorreu um erro ao carregar dados do relatório.', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    const onSubmit = async (data) => {
        try {
            setIsSearched(true);
            setPage(0);
            loadReportData(data.id_empresas, data.id_pessoa, data.id_equipamento, data.id_produto, data.isExtra, data.data_inicio, data.data_fim);
        } catch (err) {
            exibirAlerta('Erro', 'Erro ao carregar dados do relatório', 'error');
            setIsSearched(false);
        }
    }

    const listaColaboradores = async (currentPage = 0, initialPageValue = false, filterValue = "") => {
        if (!selectedEmpresaId) return;

        if (initialPageValue) {
            setPessoas([]);
            setPagePessoas(0);
            setHasMorePessoas(true);
        }

        try {
            setIsLoadingPessoas(true);

            const filters = {
                id_empresa: selectedEmpresaId,
                limit: 10,
                offset: (initialPageValue ? 0 : currentPage) * 10,
            };

            // if nome is only number, then it's matricula
            if (filterValue && !isNaN(filterValue)) {
                filters.matricula = filterValue;
                delete filters.nome;
            } else {
                filters.nome = filterValue;
                delete filters.matricula;
            }

            filters.isFilter = true;
            const response = await listaUsuariosFilter(filters);
            const newOptions = response.data.data;

            setPessoas((prevOptions) => [...prevOptions, ...newOptions]);
            setHasMorePessoas(newOptions.length > 0);
            setPagePessoas((prevPage) => prevPage + 1);
        } catch (error) {
            exibirAlerta('Erro', 'Erro ao carregar colaboradores', 'error');
        } finally {
            setIsLoadingPessoas(false);
        }
    }

    const listaEquipamentos = async (currentPage = 0, initialPageValue = false, filterValue = "") => {
        if (!selectedEmpresaId) return;

        if (initialPageValue) {
            setEquipamentos([]);
            setPageEquipamentos(0);
            setHasMoreEquipamentos(true);
        }

        try {
            setIsLoadingEquipamentos(true);

            const filters = {
                id_empresa: selectedEmpresaId,
                limit: 10,
                offset: (initialPageValue ? 0 : currentPage) * 10,
            };

            filters.nome = filterValue;
            filters.isFilter = true;

            const response = await carregaEquipamentos(filters);
            const newOptions = response.data.data;

            setEquipamentos((prevOptions) => [...prevOptions, ...newOptions]);
            setHasMoreEquipamentos(newOptions.length > 0);
            setPageEquipamentos((prevPage) => prevPage + 1);
        } catch (error) {
            exibirAlerta('Erro', 'Erro ao carregar equipamentos', 'error');
        } finally {
            setIsLoadingEquipamentos(false);
        }
    }

    const listaProdutosPage = async (currentPage = 0, initialPageValue = false, filterValue = "") => {
        if (!selectedEmpresaId) return;

        if (initialPageValue) {
            setProdutos([]);
            setPageProdutos(0);
            setHasMoreProdutos(true);
        }

        try {
            setIsLoadingProdutos(true);

            const filters = {
                id_empresa: selectedEmpresaId,
                limit: 10,
                offset: (initialPageValue ? 0 : currentPage) * 10,
            };

            filters.nome = filterValue;
            filters.isFilter = true;

            const response = await listaProdutos(filters);
            const newOptions = response.data.data;

            setProdutos((prevOptions) => [...prevOptions, ...newOptions]);
            setHasMoreProdutos(newOptions.length > 0);
            setPageProdutos((prevPage) => prevPage + 1);
        } catch (error) {
            exibirAlerta('Erro', 'Erro ao carregar produtos', 'error');
        } finally {
            setIsLoadingProdutos(false);
        }
    }

    useEffect(() => {
        const requiredPermissionsView = ["admin", "admin_retiradas", "list_retiradas"];
        checkPermissionsAndRedirect(requiredPermissionsView);


        let defaultEmpresaId = null;
        const selectedEmpresaIdSession = getEmpresaIdSession();
        if (selectedEmpresaIdSession) {
            defaultEmpresaId = selectedEmpresaIdSession;
            setSelectedEmpresaId(selectedEmpresaIdSession);
        }

        listaEmpresas(null, null, null, true)
            .then((response => {
                exibirDialog('Carregando dados da Empresa...');
                const empresasData = response?.data.data;
                setEmpresas(empresasData);

                if (!selectedEmpresaIdSession) {
                    defaultEmpresaId = empresasData[0].id;
                    setSelectedEmpresaId(empresasData[0].id);
                    setEmpresaIdSession(empresasData[0].id);
                }

                const defaultValues = {
                    id_empresas: defaultEmpresaId,
                    id_pessoa: '',
                    id_equipamento: '',
                    id_produto: '',
                    isExtra: 'ambos',
                    data_inicio: initialDataInicio,
                    data_fim: initialDataFim
                };
                reset(defaultValues);

                loadReportData(defaultEmpresaId, null, null, null, defaultValues.isExtra, defaultValues.data_inicio, defaultValues.data_fim);
            }))
            .catch((error) => {
                exibirAlerta('Erro', 'Erro ao carregar empresas', 'error');
            })
            .finally(() => {
                handleCloseDialog();
            });

        return () => {
            reset();
        }
    }, []);

    useEffect(() => {
        listaColaboradores(0, true, "");
        listaEquipamentos(0, true, "");
        listaProdutosPage(0, true, "");
    }, [selectedEmpresaId]);

    useEffect(() => {
        if (!openForm) {
            const id_empresas = getValues('id_empresas');
            const id_pessoa = getValues('id_pessoa');
            const id_equipamento = getValues('id_equipamento');
            const id_produto = getValues('id_produto');
            const isExtra = getValues('isExtra');
            const data_inicio = getValues('data_inicio');
            const data_fim = getValues('data_fim');

            if (!id_empresas || !data_inicio || !data_fim) {
                return;
            }

            loadReportData(id_empresas, id_pessoa, id_equipamento, id_produto, isExtra, data_inicio, data_fim);
        }
    }, [page, rowsPerPage, openForm]);

    console.log(produtos)
    return (
        <>
            <Helmet title="Retiradas" defer={false} />

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={3}
            >
                <Grid item xs={12}>
                    <Breadcrumbs>
                        <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao>
                        <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao>
                        <LinkNavegacao to='/epis/retiradas'>Retiradas</LinkNavegacao>
                        <Typography variant='span'>Retiradas</Typography>
                    </Breadcrumbs>
                    <PageTitle icon={<BlueprintIcon fontSize='large' />} title="Retiradas" />
                </Grid>

                <Grid container item xs={12} spacing={3} component="form" onSubmit={handleSubmit(onSubmit)}>
                    <Grid container item xs={12} md={12} spacing={3}>
                        <Grid item xs={12} md={4}>
                            <SelectEmpresaFilter
                                empresas={empresas}
                                id_empresas={empresas}
                                defaultValue={selectedEmpresaId}
                                enableOptionAll={true}
                                onChangeValue={(value) => {
                                    setIsSearched(false);
                                    setValue('id_empresas', value, { shouldDirty: true });
                                    setValue('id_pessoa', null, { shouldDirty: true })
                                    if (value !== 'all') {
                                        setSelectedEmpresaId(value);
                                        setEmpresaIdSession(value);
                                    } else {
                                        setSelectedEmpresaId(null);
                                        // setEmpresaIdSession(null);
                                    }
                                }}
                                textHelper={false}
                            />
                        </Grid>

                        {pessoas &&
                            <Grid item xs={12} md={4}>
                                <TooltipSelectDisabled isDisabled={selectedEmpresaId}>
                                    <PaginatedUserAutocomplete
                                        name="id_pessoa"
                                        control={control}
                                        label="Colaborador"
                                        disabled={!selectedEmpresaId}
                                        options={pessoas}
                                        getOptionLabel={(option) => {
                                            // verify if the user exists in pessoas
                                            const pessoa = pessoas.find(p => p.id === option);
                                            return pessoa ? `${pessoa.matricula} - ${pessoa.nome}` : '';
                                        }}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} key={option.id} disabled={option.status === 0}>
                                                {option.matricula} - {option.nome} {option.status === 0 ? '- (Inativo)' : ''}
                                            </MenuItem>
                                        )}
                                        onChange={(event, value) => {
                                            setIsSearched(false);
                                            setValue('id_pessoa', value ? value.id : null, { shouldDirty: true });
                                            if (value) {
                                                clearErrors('id_pessoa')
                                            } else {
                                                listaColaboradores(0, true);
                                            }
                                        }}
                                        onInput={(event) => {
                                            setPessoas([]);
                                            setPagePessoas(0);
                                            setHasMorePessoas(true);
                                            const filterValue = event.target.value ?? "";
                                            listaColaboradores(0, true, filterValue);
                                        }}
                                        hasMore={hasMorePessoas}
                                        loadOptionsFn={() => listaColaboradores(pagePessoas, false, "")}
                                        helperText={getFormErrorMessage(errors, 'id_pessoa')}
                                        error={!!errors.id_pessoa}
                                        loading={isLoadingPessoas}
                                        textFieldSize="small"
                                        textFieldStyle={{ backgroundColor: '#fff' }}
                                    />
                                </TooltipSelectDisabled>
                            </Grid>
                        }

                        {produtos &&
                            <Grid item xs={12} md={4}>
                                <TooltipSelectDisabled isDisabled={selectedEmpresaId}>
                                    <PaginatedUserAutocomplete
                                        name="id_produto"
                                        control={control}
                                        label="Produto"
                                        disabled={!selectedEmpresaId}
                                        options={produtos}
                                        getOptionLabel={(option) => option?.nome ?? ''}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} key={option.id}>
                                                {option.ca ? option.ca + ' - ' : ''} {option.nome}
                                            </MenuItem>
                                        )}
                                        onChange={(event, value) => {
                                            setIsSearched(false);
                                            setValue('id_produto', value ? value.id : null, { shouldDirty: true });
                                            if (value) {
                                                clearErrors('id_produto');
                                            } else {
                                                listaProdutosPage(0, true);
                                            }
                                        }}
                                        onInput={(event) => {
                                            setProdutos([]);
                                            setPageProdutos(0);
                                            setHasMoreProdutos(true);
                                            const filterValue = event.target.value ?? "";
                                            listaProdutosPage(0, true, filterValue);
                                        }}
                                        hasMore={hasMoreProdutos}
                                        loadOptionsFn={() => listaProdutosPage(pageProdutos, false, "")}
                                        helperText={getFormErrorMessage(errors, 'id_produto')}
                                        error={!!errors.id_produto}
                                        loading={isLoadingProdutos}
                                        textFieldSize="small"
                                        textFieldStyle={{ backgroundColor: '#fff' }}
                                    />
                                </TooltipSelectDisabled>
                            </Grid>
                        }

                        {equipamentos &&
                            <Grid item xs={12} md={4}>
                                <TooltipSelectDisabled isDisabled={selectedEmpresaId}>
                                    <PaginatedUserAutocomplete
                                        name="id_equipamento"
                                        control={control}
                                        label="Equipamento"
                                        disabled={!selectedEmpresaId}
                                        options={equipamentos}
                                        getOptionLabel={(option) => option?.nome ?? ''}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} key={option.id} disabled={option.status === 0}>
                                                {option.nome} {option.status === 0 ? '- (Inativo)' : ''}
                                            </MenuItem>
                                        )}
                                        onChange={(event, value) => {
                                            setIsSearched(false);
                                            setValue('id_equipamento', value ? value.id : null, { shouldDirty: true });
                                            if (value) {
                                                clearErrors('id_equipamento');
                                            } else {
                                                listaEquipamentos(0, true);
                                            }
                                        }}
                                        onInput={(event) => {
                                            setEquipamentos([]);
                                            setPageEquipamentos(0);
                                            setHasMoreEquipamentos(true);
                                            const filterValue = event.target.value ?? "";
                                            listaEquipamentos(0, true, filterValue);
                                        }}
                                        hasMore={hasMoreEquipamentos}
                                        loadOptionsFn={() => listaEquipamentos(pageEquipamentos, false, "")}
                                        helperText={getFormErrorMessage(errors, 'id_equipamento')}
                                        error={!!errors.equipamento}
                                        loading={isLoadingEquipamentos}
                                        textFieldSize="small"
                                        textFieldStyle={{ backgroundColor: '#fff' }}
                                    />
                                </TooltipSelectDisabled>
                            </Grid>
                        }

                        <Grid item xs={12} md={4}>
                            <Controller
                                name="isExtra"
                                control={control}
                                defaultValue="ambos"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        select
                                        fullWidth
                                        label="Buscar Retiradas"
                                        size="small"
                                        onChange={(event) => {
                                            setIsSearched(false);
                                            field.onChange(event.target.value);
                                        }}
                                        InputProps={{ style: { backgroundColor: '#fff' } }}
                                    >
                                        <MenuItem value="ambos">Ambos</MenuItem>
                                        <MenuItem value="no_extra">Somente Retiradas</MenuItem>
                                        <MenuItem value="only_extra">Somente Retiradas Extras</MenuItem>
                                    </TextField>
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <DateRangePicker
                                value={dateRange}
                                bgColor='#fff'
                                onChange={(value) => {
                                    setDateRange(value);
                                    const [start, end] = value;
                                    setValue('data_inicio', start ? dayjs(start).format('YYYY-MM-DD') : '');
                                    setValue('data_fim', end ? dayjs(end).format('YYYY-MM-DD') : '');
                                    setIsSearched(false);
                                }}
                                onReset={() => {
                                    setIsSearched(false);
                                    setDateRange([null, null]);
                                    setValue('data_inicio', '');
                                    setValue('data_fim', '');
                                }}
                                hasError={errors.data_inicio || errors.data_fim}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <Button
                                type='submit'
                                color='primary'
                                variant='contained'
                                disabled={isLoading || Object.keys(errors).length > 0 || isSearched}
                                startIcon={isLoading ? <CircularProgress size={16} sx={{ color: "textSecondary" }} /> : <FilterAlt />}
                            >
                                Filtrar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <TableContainer component={Paper}>
                        <Table aria-label="Retiradas">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        colSpan={8}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            startIcon={<DownloadIcon />}
                                            sx={{
                                                textTransform: "none",
                                                fontSize: 12,
                                                borderRadius: 2,
                                            }}
                                            onClick={() => {
                                                window.location.href = "/epis/relatorios/retiradas";
                                            }}
                                        >
                                            Exportar
                                        </Button>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ display: "flex" }}>
                                    <TableCell sx={{ flex: 1 }}>Matrícula</TableCell>
                                    <TableCell sx={{ flex: 2 }}>Nome</TableCell>
                                    <TableCell sx={{ flex: 2 }}>Produto</TableCell>
                                    <TableCell sx={{ flex: 1 }}>Equipamento</TableCell>
                                    <TableCell sx={{ flex: 1 }}>Tipo Autenticação</TableCell>
                                    <TableCell sx={{ flex: 1 }}>Data</TableCell>
                                    <TableCell sx={{ flex: 1 }}>Quantidade</TableCell>
                                    <TableCell sx={{ flex: 1 }}>Retirada Extra</TableCell>
                                </TableRow>

                            </TableHead>

                            <TableBody>
                                {isLoading ? (
                                    <LoadingTableRow />
                                ) : retiradas?.length ? (
                                    retiradas.map(item => (
                                        <RetiradaRow key={item.id} data={item} />
                                    ))
                                ) : (
                                    <EmptyTableRow />
                                )}
                            </TableBody>
                        </Table>

                        <CustomTablePagination
                            numTotalItems={numTotalItems}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            setPage={setPage}
                            setRowsPerPage={setRowsPerPage}
                        />
                    </TableContainer>
                </Grid>
            </Grid>
        </>
    )
}